  <template>
  <div class="sio-table-container">
    <b-table striped bordered responsive no-border-collapse :items="sioFilter" :fields="fields">

      <template v-slot:thead-top>
        <b-tr>
          <b-th colspan="6" class="text-left bg-head" style="border-bottom: 1px solid rgba(0, 0, 0, 0.3); border-right: 1px solid rgba(0, 0, 0, 0.12); color : #fff">SIO NUMBER :  {{ getSioNumber() }}</b-th>
        </b-tr>
      </template>

      <template v-slot:cell(START_DATE_OPR)="data">
        {{ data.value !== '-' ? new Date(data.value).toLocaleString('en-GB', dateFormat) : '-' }}
      </template>

      <template v-slot:cell(END_DATE_OPR)="data">
        {{ data.value !== '-' ? new Date(data.value).toLocaleString('en-GB', dateFormat) : '-' }}
      </template>
    </b-table>
  </div>
</template>
<script>
export default {
  name: 'sio',
  props: {
    detailId: {
      type: String,
      required: false // true if api ready
    }
  },
  data() {
    return {
      dateFormat: { day: 'numeric', month: 'short', year: 'numeric' },
      fields: [
        {key : 'KEGIATAN', label : 'Kegiatan', thClass: 'bg-head'},
        {key : 'AREA_KERJA', label : 'Area Kerja', thClass: 'bg-head'},
        {key : 'PIC_OPR', label : 'Penanggun Jawab Operasi', thClass: 'bg-head'},
        {key : 'DEPT_OPR', label : 'Dept Penanggung Jawab Operasi', thClass: 'bg-head'},
        {key : 'START_DATE_OPR', label : 'Tgl Mulai Izin', thClass: 'bg-head'},
        {key : 'END_DATE_OPR', label : 'Tgl Berakhir Izin', thClass: 'bg-head'},
      ],
      items: [
        { 
          nomor_iso: '20030200', 
          kegiatan_dan_area_kerja: 'Road; Jakarta', 
          tgl_mulai_ijin: 1576067992682, 
          tgl_berakhir_ijin: 1576067992682, 
          penanggung_jawab_operasi: 'Muhyiddin', 
          dept_penanggung_jawab_operasi: 'Dept Jalan dan Bangunan' }
      ]
    }
  },
  methods: {
    getSioNumber(){
      const self = this
      if(self.$store.state.datatable.detail){
        return self.$store.state.datatable.detail.SIO_NUMBER
      }
      return ''
    },
    sioFilter(){
      const self = this
      if(self.$store.state.datatable.detail){
        const sioData = Object.entries(self.$store.state.datatable.detail)
  
        const sioFlag = new RegExp(/SIO_FLAG/g)

        const getSio = sioData.filter(i => i[0].match(sioFlag))

        let sioObj = []
  
        for(let i in getSio){
          sioObj.push({
            [`SIO_FLAG`] : self.$store.state.datatable.detail[`SIO_FLAG`],
            [`SIO_NUMBER`] : self.$store.state.datatable.detail[`SIO_NUMBER`]  ? self.$store.state.datatable.detail[`SIO_NUMBER`] : '-',
            [`KEGIATAN`] : self.$store.state.datatable.detail[`KEGIATAN_${parseInt(i) + 1}`]   ? self.$store.state.datatable.detail[`KEGIATAN_${parseInt(i) + 1}`] : '-',
            [`AREA_KERJA`] : self.$store.state.datatable.detail[`AREA_KERJA_${parseInt(i) + 1}`]   ? self.$store.state.datatable.detail[`AREA_KERJA_${parseInt(i) + 1}`] : '-',
            [`PIC_OPR`] : self.$store.state.datatable.detail[`PIC_OPR_${parseInt(i) + 1}`]   ? self.$store.state.datatable.detail[`PIC_OPR_${parseInt(i) + 1}`] : '-',
            [`DEPT_OPR`] : self.$store.state.datatable.detail[`DEPT_OPR_${parseInt(i) + 1}`]   ? self.$store.state.datatable.detail[`DEPT_OPR_${parseInt(i) + 1}`] : '-',
            [`START_DATE_OPR`] : self.$store.state.datatable.detail[`START_DATE_OPR_${parseInt(i) + 1}`]   ? self.$store.state.datatable.detail[`START_DATE_OPR_${parseInt(i) + 1}`] : '-',
            [`END_DATE_OPR`] : self.$store.state.datatable.detail[`END_DATE_OPR_${parseInt(i) + 1}`]   ? self.$store.state.datatable.detail[`END_DATE_OPR_${parseInt(i) + 1}`] : '-',
          })
        }
        return sioObj
      }
    }
  },
}
</script>
<style lang="scss">
  @import "~/assets/scss/components/sio.scss";
</style>
